const InitNavigation = () => {
  const body = document.body;
  const html = document.documentElement;
  const siteNavigation = document.getElementById('site-navigation');

  if (!siteNavigation) {
    return;
  }

  const button = siteNavigation.getElementsByTagName('button')[0];

  if ('undefined' === typeof button) {
    return;
  }

  const menu = siteNavigation.getElementsByTagName('ul')[0];

  if ('undefined' === typeof menu) {
    button.style.display = 'none';
    return;
  }

  if (!menu.classList.contains('nav-menu')) {
    menu.classList.add('nav-menu');
  }

  button.addEventListener('click', function () {
    siteNavigation.classList.toggle('toggled');

    if (button.getAttribute('aria-expanded') === 'true') {
      button.setAttribute('aria-expanded', 'false');
      body.classList.remove('is-menu-open');
      html.classList.remove('is-menu-open');
    } else {
      button.setAttribute('aria-expanded', 'true');
      body.classList.add('is-menu-open');
      html.classList.add('is-menu-open');
    }
  });

  document.addEventListener('click', function (event) {
    const isClickInside = siteNavigation.contains(event.target);

    if (!isClickInside) {
      siteNavigation.classList.remove('toggled');
      button.setAttribute('aria-expanded', 'false');
      body.classList.remove('is-menu-open');
      html.classList.remove('is-menu-open');
    }
  });
};
export default InitNavigation;
